<template>
  <main>
    <v-container class="grey lighten-4 fill-height">
      <v-row>
            <v-col class="mx-auto">
              <v-card class="elevation-12 ma-3">
                  <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <v-toolbar-title>Översikt</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-5">
                    <div class="text-right mr-12">
                    <date-range-picker
            ref="picker"
            opens= "left"
            :appendToBody= "1"
            :autoApply= 1
            :locale-data="{ direction: 'ltr',
    format: 'dd/mm/yyyy',
    separator: ' - ',
    applyLabel: 'Apply',
    cancelLabel: 'Cancel',
    weekLabel: 'W',
    customRangeLabel: 'Custom Range',
    daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    firstDay: 0 }"
            v-model="dateRange"
            @update="getdata"
    >
        <template v-slot:input="picker" style="min-width: 350px;">
            {{ toDDMMYY(picker.startDate) }} - {{ toDDMMYY(picker.endDate) }}
        </template>
    </date-range-picker>
    </div>
    <v-row>
    <v-col>
  <v-card
    max-width="344"
    outlined
  >
    <v-list-item three-line>
      <v-list-item-avatar
        tile
        size="80"
        color="#ffa500"
      ><v-icon dark x-large>fa-calendar-check</v-icon></v-list-item-avatar>
      <v-list-item-content>
        <div class="overline mb-4">Number of schedules</div>
        <v-list-item-title class="headline mx-5"><h2>{{count.schedules}}</h2></v-list-item-title>
      </v-list-item-content>

    </v-list-item>
  </v-card>
    </v-col>
    <v-col>
  <v-card
    max-width="344"
    outlined
  >
    <v-list-item three-line>
      <v-list-item-avatar
        tile
        size="80"
        color="#ffa500"
      ><v-icon dark x-large>fa-user-circle</v-icon></v-list-item-avatar>
      <v-list-item-content>
        <div class="overline mb-4">Number of users</div>
        <v-list-item-title class="headline mx-5"><h2>{{count.users}}</h2></v-list-item-title>
      </v-list-item-content>

    </v-list-item>
  </v-card>
    </v-col>
    <v-col>
  <v-card
    max-width="344"
    outlined
  >
    <v-list-item three-line>
      <v-list-item-avatar
        tile
        size="80"
        color="#ffa500"
      ><v-icon dark x-large>fa-list </v-icon></v-list-item-avatar>
      <v-list-item-content>
        <div class="overline mb-4">Number of answers given</div>
        <v-list-item-title class="headline mx-5"><h2>{{count.participants}}</h2></v-list-item-title>
      </v-list-item-content>

    </v-list-item>
  </v-card>
    </v-col>
  </v-row>
                </v-card-text>
            </v-card>
            </v-col> 
        </v-row>
    </v-container>
  </main>
</template>

<script>
import axios from "axios";
import store from "../../../store";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
// import schedule from "./tabs/schedules"
export default {
    data() {
        return {
            tab: null,
            tabs: 2,
            store: store,
            count: [],
            dateRange: {
startDate: new Date(),
endDate: new Date()
},
dateFormat:'mm/dd/yyyy'
            
        };
    },
    components:{
        DateRangePicker,
    },
    created: function() {
        if (this.store.state.user.role == "user")
            this.$router.replace("/dashboard");
        if (!this.store.state.isLoggedIn) this.$router.replace("/login");
        this.getdata()
    },
    methods:{
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
        toYYMMDD(date) {
            let dated = new Date(date);
            return `${dated.getFullYear()}-${dated.getMonth() +
                1}-${dated.getDate()}`;
        },
        getdata: async function() {
            console.log(this.dateRange)
            let bodyFormData = new FormData();
            bodyFormData.set("start", this.toYYMMDD(this.dateRange.startDate));
            bodyFormData.set("end", this.toYYMMDD(this.dateRange.endDate));
            var config = {
            method: "post",
            url: `${this.store.state.baseURL}admindashboard`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            },
            data:bodyFormData
        };
        let resp = await axios(config);
        this.count = resp.data
        },
    }
};
</script>
